import { render, staticRenderFns } from "./OrderMenuCheckout.vue?vue&type=template&id=77486c54&scoped=true"
import script from "./OrderMenuCheckout.vue?vue&type=script&lang=js"
export * from "./OrderMenuCheckout.vue?vue&type=script&lang=js"
import style0 from "./OrderMenuCheckout.vue?vue&type=style&index=0&id=77486c54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77486c54",
  null
  
)

export default component.exports